var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlarmClockAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7651 2.10998C16.4233 1.89838 15.9731 2.0013 15.7595 2.33985C15.5459 2.67841 15.6498 3.1244 15.9916 3.33599L19.8834 5.74562C20.2252 5.95722 20.6754 5.8543 20.889 5.51574C21.1026 5.17719 20.9987 4.7312 20.6569 4.5196L16.7651 2.10998Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.2405 2.33986C8.45409 2.67841 8.3502 3.1244 8.00844 3.33599L4.11657 5.74562C3.77481 5.95722 3.32461 5.8543 3.11102 5.51574C2.89742 5.17718 3.00131 4.7312 3.34307 4.5196L7.23494 2.10998C7.5767 1.89838 8.0269 2.0013 8.2405 2.33986Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C16.8362 22 20.7567 18.1162 20.7567 13.3253C20.7567 8.53447 16.8362 4.6507 12 4.6507C7.16384 4.6507 3.24335 8.53447 3.24335 13.3253C3.24335 18.1162 7.16384 22 12 22ZM12.75 9.00001V12.6893L15.0303 14.9697C15.3232 15.2626 15.3232 15.7374 15.0303 16.0303C14.7374 16.3232 14.2626 16.3232 13.9697 16.0303L11.4697 13.5303C11.329 13.3897 11.25 13.1989 11.25 13V9.00001C11.25 8.5858 11.5858 8.25001 12 8.25001C12.4142 8.25001 12.75 8.5858 12.75 9.00001Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarmClockAlt);
export default __webpack_public_path__ + "static/media/alarm-clock-alt.d5549a68046f7e71fe8aa9a56c867515.svg";
export { ForwardRef as ReactComponent };